module.exports = __webpack_public_path__ + "img/blackcanvas-bodlak-1.18c5bc91.png";